import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NavMenu from '../common/nav-menu/nav-menu.component';
import { Footer } from '../common/footer/footer.component';
import { navMenuActions } from '../../store/external/nav-menu-reducer/nav-menu.reducer';
import { NoSubscription } from '../external/dashboard/no-subscription/no-subscription.component';
import '../common/common-css/global.css';

class ExternalLayout extends Component {
    componentDidMount() {
        this.updateScale();
        window.addEventListener('resize', this.updateScale);

        this.observer = new MutationObserver(this.updateScale);
        this.observer.observe(document.body, { childList: true, subtree: true });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScale);
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    updateScale = () => {
        const customBody = document.querySelector('.custom-body');
        const customModals = document.querySelectorAll('.fade.modal.show'); // Select all modals
        const customConfirmatonBlurModals = document.querySelectorAll('.confirmation-blur-background'); // Select all confirmation blur backgrounds
    
        if (customBody) {
            let scaleFactor = 1;
            let modalScaleFactor = 1;
    
            if (window.innerWidth <= 1410) {
                scaleFactor = window.innerWidth / 1445;
                modalScaleFactor = window.innerWidth / 1845;
                customBody.style.transform = `scale(${scaleFactor})`;
                customBody.style.transformOrigin = 'top left';
            } else {
                customBody.style.transform = 'none';
            }
    
            if (window.innerWidth <= 1746) {
                modalScaleFactor = window.innerWidth / 1945;
            }
            
            const centerModal = (modal) => {
                modal.style.position = 'fixed';
                modal.style.top = '50%';
                modal.style.left = '50%';
                modal.style.transformOrigin = 'center center';
                modal.style.transform = `translate(-50%, -50%) scale(${modalScaleFactor})`;
                modal.style.paddingLeft = '0';
            };
    
            customModals.forEach(centerModal);
            customConfirmatonBlurModals.forEach(centerModal);
        }
    };
    

    render() {  
        return (
            <div className='custom-body'>
                <NavMenu
                    isUserLoggedIn={this.props.isUserLoggedIn}
                    renderBodyAndFooter={this.renderBodyAndFooter}></NavMenu>
                {
                    this.props.newNavItems.length > 0 ? 
                    <>
                        <div className="main-wrapper">
                            {this.props.children}
                        </div>
                        <Footer/>
                    </> : 
                   <NoSubscription customClass="loading-page" title="Launching Application, Please Wait…"/>
                }
            </div>
        );
    }
}

export default connect(
    state => state.navMenu,
    dispatch => bindActionCreators(navMenuActions, dispatch),
    null,
    {
        pure: false
    }
)(ExternalLayout);
